export default __webpack_public_path__ + "static/pattern-1-c76735dce9ec904a59e8d160f7e3dda9.png";